import {createAction, createAllActions} from 'web-app/util/redux/typed-action-helpers';

const domain = 'MAIN_NAVIGATION';

export const {
    action: fetchMenu,
    success: fetchMenuSuccess,
    failed: fetchMenuFailed,
} = createAllActions(
    `${domain}/FETCH_MENU`,
    () => ({}),
    (menuItems: any) => ({menuItems}),
);

export const {action: focusMode} = createAction(`${domain}/FOCUS_MODE`, (focus: boolean) => ({focus}));

export const {action: toggleMainNavigation} = createAction(
    `${domain}/TOGGLE_MAIN_NAVIGATION`,
    (collapsed: boolean) => ({collapsed}),
);

export const {action: updateInstitutionTitle} = createAction(
    `${domain}/UPDATE_INSTITUTION_NAME`,
    (institutionName: string, institutionId: string) => ({institutionName, institutionId}),
);

export const {action: toggleProfileMenu} = createAction(`${domain}/TOGGLE_PROFILE_MENU`, () => ({}));

export const {action: setProfileMenuOpen} = createAction(`${domain}/SET_PROFILE_MENU_OPEN`, (isOpen: boolean) => ({
    isOpen,
}));
